import React, { useState } from 'react'
import HelpCard from '../../HelpCard'

function StockItemSummaryHelp(props) {

    const fields = [
        { id: "1", name: "Period", shortcutKey: "F2", state: props.setShow },
        { id: "2", name: "Stock Item", shortcutKey: "F3", state: props.setStockItem },
        { id: "3", name: "Show Profit", shortcutKey: "F4" },
        { id: "4", name: "Godown Type", shortcutKey: "F5", state: props.setGodownWise  },
        { id: "5", name: "Change View", shortcutKey: "F6", state: props.setChangeView },
        { id: "6", name: "Exception Reorts", shortcutKey: "F7" },
        { id: "7", name: "Apply Filter", shortcutKey: "F8" },
        { id: "8", name: "Configure", shortcutKey: "F9" },
    ]
    return (
        <div>
            {
                fields.map((item, index) => {
                    return (
                        <HelpCard key={item.id} fields={item} />
                    )
                })
            }

        </div>
    )
}

export default StockItemSummaryHelp
